<div class="modal-body">
    <input type="text" [(ngModel)]="searchText" placeholder="Search..." class="form-control">
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>

    <button type="button" class="btn btn-primary" (click)="onOK()">Search</button>
</div>